var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAlert = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 8,
  fill: "#ED0A34"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#svg-public/img/icons/alert.svg__clip0)",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.952 4.499a.954.954 0 10-1.904 0l.204 4.288a.75.75 0 001.496 0l.204-4.288z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 11.25,
  r: 0.75
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "svg-public/img/icons/alert.svg__clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(7 3.5)",
  d: "M0 0h2v9H0z"
})))));
export { SvgAlert as ReactComponent };